import React from 'react';
import { useAppointmentStateUnsafe } from '../../context/Appointment/appointment';
import { Navigate } from 'react-router-dom';

export interface AppointmentRouteProps {
    children: React.ReactNode;
}

/** Renders a route only if an appointment is available. Otherwise, redirects to the homepage. */
export const AppointmentRoute: React.FC<AppointmentRouteProps> = ({ children }) => {
    const appointment = useAppointmentStateUnsafe();

    return appointment ? <>{children}</> : <Navigate replace to={'/'} />;
};